
<div class="container-fluid row p-0 m-0 h-100">
    <div class="col-12 p-0">
        <router-outlet></router-outlet>
    </div>
</div>